import { Box } from "@mui/material";
import styled from "styled-components";

export const Container = styled.div`
	background-color: rgba(0, 0, 0, 0.5);
	width: auto;
	//min-height: 20px;
	font-family: "Roboto", "Helvetica", "Arial", sans-serif;
	font-weight: 405;
	font-size: 0.85rem;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 25px;
	color: white;
	flex-wrap: nowrap;

	//overflow: hidden;
	position: relative;
	padding: 9px;

	gap: 5px;

	> svg,
	> img {
		//width: 18px;
		height: 18px;
	}

	@media (max-width: 599px) {
		padding: 8px;
		font-size: 11.5px;
		> svg,
		> img {
			//width: 18px;
		}
	}

	/* border: 0.2rem solid #c0c0c0;
	box-shadow: 0 0 0.2rem #c0c0c0, 0 0 0.2rem #c0c0c0, 0 0 2rem #bc13fe,
		0 0 0.8rem #bc13fe, 0 0 2.8rem #bc13fe, inset 0 0 1.3rem #bc13fe; */
`;

export const UserProfileImage = styled(Box)({
	display: "flex",
	justifyContent: "center",
	"svg, img": { width: "37px", height: "37px" }
});

export const AppBarUserBox = styled(Box)`
	width: 62px;
	right: 0;
	position: relative;
	display: flex;
	align-items: center;
	padding: 0;
	margin: 0rem;
	justify-content: center;

	& img {
		border-radius: 30px;
	}

	@media (max-width: 599px) {
		width: 40px;
	}
`;
